module.exports = __webpack_public_path__ + "img/icon_language_setting.c18028ad.svg";